const SET_COMPANY_USER_ID = 'SET_COMPANY_USER_ID';

export const setUserIdAction = userId => dispatch => {
  dispatch({
    type: SET_COMPANY_USER_ID,
    payload: userId,
  });
};
